var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
var Restore = function (props) { return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 25 16" }),
    React.createElement("g", { id: "UX-Specification-document", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" },
        React.createElement("g", { id: "Insights-homepage,-Archived-surveys-tab---Desktop", transform: "translate(-951.000000, -291.000000)", stroke: "#3D3D35", strokeWidth: "1.3" },
            React.createElement("g", { id: "Group-10", transform: "translate(145.000000, 251.000000)" },
                React.createElement("g", { id: "Group-25", transform: "translate(797.000000, 30.000000)" },
                    React.createElement("g", { id: "Restore-Survey-copy-3", transform: "translate(10.000000, 10.000000)" },
                        React.createElement("path", { d: "M1.13,8.6 C1.63832727,6.19028298 3.76452169,4.46563236 6.2272707,4.46537761 C8.69001971,4.46512285 10.8165709,6.18933356 11.3253967,8.59894536 C11.8342225,11.0085572 10.5863263,13.4453332 8.3337301,14.4407946 C6.08113394,15.4362559 3.43918251,14.718471 2,12.72", id: "Path" }),
                        React.createElement("polyline", { id: "Path", strokeLinejoin: "round", points: "0.24 6.64 1.08 8.72 3.13 7.89" }),
                        React.createElement("polyline", { id: "Path", strokeLinejoin: "round", points: "3.14 3.17 3.14 0.97 22.87 0.97 22.87 11.88 13.2 11.88" })))))))); };
export default Restore;
